/**
 * Shape of the `Document` JSON string on a fixed-DOCX OrgContractDocument.
 *
 * `url`/`fileId` point at the converted PDF (used for the signed-preview + as a fallback
 * viewer). `docxUrl`/`docxFileId` point at the merged/edited .docx — the SOURCE OF TRUTH the
 * review page renders and live-edits. Older contracts predate docx persistence and carry no
 * `docxUrl`; the review page re-merges from the template + FormData in that case.
 */
export interface FixedDocxDocument {
  type?: string;
  /** Converted PDF url. */
  url?: string;
  /** Converted PDF fileId. */
  fileId?: string;
  fileName?: string;
  /** Merged/edited .docx url (source of truth for the editable review). */
  docxUrl?: string;
  /** Merged/edited .docx fileId. */
  docxFileId?: string;
}

export function parseDocxDocument(raw: string | null | undefined): FixedDocxDocument | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as FixedDocxDocument;
  } catch {
    return null;
  }
}
